import EndorsementResponsePolicy from './EndorsementResponsePolicy';
import {
	BuildingResponseCommercialExisting,
} from '@app/models/api';

export default class EndorsementResponsePolicyCommercial extends EndorsementResponsePolicy {

	public buildings: BuildingResponseCommercialExisting[] = [];

	public constructor() {
		super();
	}

	// Checks to see if a generic object is an instance of class EndorsementResponsePolicyCommercial
	public static isEndorsementResponsePolicyCommercial = (objToCheck: any): objToCheck is EndorsementResponsePolicyCommercial => {
		let objCasted: EndorsementResponsePolicyCommercial = objToCheck as EndorsementResponsePolicyCommercial;
		return objCasted.buildings !== undefined;
	}
}